import { useEffect, useState } from "react";
import PublicRoutes, { PUBLIC_ROUTES } from "./public.routes";
import { useStateValue } from "./state/StateProvider";
import "./App.sass";
import { auth, db } from "./firebase";
import { SET_USER } from "./state/Constants";
import ProtectedRoutes from "./protected.routes";
import Layout from "./components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "./utils/Spinner";
import { doc, getDoc } from "firebase/firestore";

function App() {
	const [loading, setLoading] = useState(true);
	const [{ user }, action] = useStateValue();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		auth.onAuthStateChanged(async (userCredenetials) => {
			if (userCredenetials && userCredenetials.emailVerified) {
				setLoading(true);
				const userData = (
					await getDoc(doc(db, "users", userCredenetials.uid))
				).data();

				console.log(userData);

				action({ type: SET_USER, payload: { user: userData } });
				if (location.pathname === "/login" || location.pathname === "/")
					userData?.showWelcomeScreen
						? navigate("/welcome")
						: navigate("/batons");
			} else {
				console.log(location.pathname);
				action({ type: SET_USER, payload: { user: null } });
				if (!PUBLIC_ROUTES.includes(location.pathname)) navigate("/");
			}
			setLoading(false);
		});
	}, []);

	console.log(user);

	return (
		<Layout>
			{loading ? (
				<Spinner />
			) : (
				<>
					{user && <ProtectedRoutes />}
					<PublicRoutes />
				</>
			)}
		</Layout>
	);
}

export default App;
